import { SchemaWithClient } from '../types/SchemaWithClient';
import { Client } from '../services/Client';
import { NumberField } from '../components/Table/fields/NumberField';
import { TextField } from '../components/Table/fields/TextField';
import { SelectField } from '../components/Table/fields/SelectField';
import { enumItems } from './enumItems';
import { SPSelectField } from '../components/Table/fields/SPSelectField';
import { SPNumberField } from '../components/Table/fields/SPNumberField';
import { SPTextField } from '../components/Table/fields/SPTextField';
import { corporate } from './corporate';

export const corporatePayment: SchemaWithClient<any> = {
  name: 'Corporate Payment',
  pluralName: 'Corporate Payment',
  tabs: [
    {
      id: 1,
      label: 'General',
      name: 'general',
    },
  ],
  columns: {
    name: {
      name: 'Payments name',
      fieldRenderer: TextField,
      slidePaneFieldRenderer: SPTextField,
      fieldType: 'text',
    },
    iban: {
      name: 'IBAN',
      fieldRenderer: TextField,
      slidePaneFieldRenderer: SPTextField,
      fieldType: 'text',
    },
    bic_code: {
      name: 'BIC Code',
      fieldRenderer: TextField,
      slidePaneFieldRenderer: SPTextField,
      fieldType: 'text',
    },
    payment_method: {
      name: 'Payment Method',
      fieldRenderer: SelectField.tableAdapter(enumItems.paymentMethod),
      slidePaneFieldRenderer: SPSelectField.tableAdapter(
        enumItems.paymentMethod
      ),
      url: enumItems.paymentMethod.client.getAllPath,
      tempSchema: enumItems.paymentMethod,
      switchboard: true,
    },
    invoice_mode: {
      name: 'Payment Frequency',
      fieldRenderer: SelectField.tableAdapter(enumItems.invoiceMode),
      slidePaneFieldRenderer: SPSelectField.tableAdapter(enumItems.invoiceMode),
      url: enumItems.invoiceMode.client.getAllPath,
      tempSchema: enumItems.invoiceMode,
      switchboard: true,
    },
    currency: {
      name: 'Currency',
      fieldRenderer: SelectField.tableAdapter(enumItems.currency),
      slidePaneFieldRenderer: SPSelectField.tableAdapter(enumItems.currency),
      url: enumItems.currency.client.getAllPath,
      tempSchema: enumItems.currency,
      switchboard: true,
    },
    corporate: {
      name: 'Corporate',
      fieldRenderer: SelectField.tableAdapter(enumItems.corporate),
      slidePaneFieldRenderer: SPSelectField.tableAdapter(enumItems.corporate),
      url: corporate.client.getAllPath,
      tempSchema: corporate,
      switchboard: true,
    },
    /* payment_deadline: {
      name: 'Payment Deadline',
      fieldRenderer: NumberField,
      slidePaneFieldRenderer: SPNumberField,
      fieldType: 'number',
    },*/
    id: {
      name: 'ID',
      required: true,
      fieldRenderer: NumberField,
      slidePaneFieldRenderer: SPNumberField,
      fieldType: 'number',
      readOnly: true,
    },
  },
  client: new Client('/corporate-payments'),
};
